import { IDENTITY_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

export async function initiateLinkedInWebSignIn(returnTo) {
  const { data } = await apiClient.get(
    `${IDENTITY_SERVICE_BASE_URL}/api/v1/auth/linkedin/web`,
    { params: { returnTo } },
  );
  return { redirectUrl: data?.redirect_url || data?.redirectUrl || "" };
}
